import React from "react";
import ViewHandymanForms from "../ViewHandymanForms/ViewHandymanForm";

const ViewHandyman = () => {
    return(
        <ViewHandymanForms type="View"/>
    )
}

export default ViewHandyman